import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URI;

class SiteAnalyticsService {
  track(payload) {
    axios.post(`${BASE}/api/site-analytics/track`, payload).catch((err) => {
      console.warn('[siteAnalytics] track failed:', err?.message);
    });
  }

  async getSummary({ from, to, period } = {}) {
    const { data } = await axios.get(`${BASE}/api/site-analytics/admin/summary`, {
      params: { from, to, period },
      headers: { Authorization: localStorage.jwtToken },
    });
    return data;
  }
}

export default new SiteAnalyticsService();
